import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const paintings = [{
  src: 'https://cdn.magicpatterns.com/uploads/2MupRVoTgcJSCi8xEJrAgW/WhatsApp_Image_2026-04-12_at_3.08.50_PM.jpg',
  alt: 'Two mothers embracing with baby — painting'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5T5Wjrq8u2Kcri8UgYgafK/WhatsApp_Image_2026-04-12_at_3.08.49_PM_(2).jpg',
  alt: 'Birth preparation breathing class — painting'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wAnfcF9VGYniPgjVdDgm8J/WhatsApp_Image_2026-04-12_at_3.08.49_PM_(1).jpg',
  alt: 'Midwife with expectant mother — painting'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bpQZ1UVPu2jrRBfv6Sstom/WhatsApp_Image_2026-04-12_at_3.08.49_PM.jpg',
  alt: 'Mother kissing newborn — painting'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7RZAjQgU7rvTrU6D4Sk7N6/WhatsApp_Image_2026-04-12_at_15.08.50.jpg',
  alt: 'Birth preparation — artwork'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uwLxT11gr1ESwsVCjyVkhN/WhatsApp_Image_2026-04-12_at_16.45.02_(2).jpg',
  alt: 'Mother breastfeeding baby with flowers — painting'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bKyUBcRUupK3k6s8d6xkwq/WhatsApp_Image_2026-04-12_at_16.45.02_(1).jpg',
  alt: 'Midwife with expectant couple — painting'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/f2u2PGmZzp6U3TcbVA2tKW/WhatsApp_Image_2026-04-12_at_16.45.02.jpg',
  alt: 'Midwife caring for mother and newborn — painting'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mz8fsnrdgWde3g7jUnmRBw/WhatsApp_Image_2026-04-12_at_16.39.32.jpg',
  alt: 'Family embracing newborn with flowers — painting'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nd6NwXn4k3jAUepTzUyAiL/WhatsApp_Image_2026-04-12_at_16.39.33.jpg',
  alt: 'Mother and child in heart embrace — painting'
}];
export function ArtworkCarousel() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  };
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    checkScroll();
    el.addEventListener('scroll', checkScroll);
    return () => el.removeEventListener('scroll', checkScroll);
  }, []);
  const scroll = (direction: 'left' | 'right') => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = 340;
    el.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth'
    });
  };
  return <section className="py-16 bg-teal-50/30" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-44">
          <h3 className="text-2xl sm:text-3xl font-serif font-medium text-teal-900 mb-2" data-id="element-45">
            Artwork Gallery
          </h3>
          <p className="text-slate-500 text-base" data-id="element-46">
            Original paintings by Alix Kennedy celebrating birth, motherhood &
            care
          </p>
        </motion.div>

        <div className="relative group" data-id="element-47">
          {/* Left arrow */}
          {canScrollLeft && <button onClick={() => scroll('left')} className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm shadow-md rounded-full p-2.5 text-teal-700 hover:bg-white transition-all opacity-0 group-hover:opacity-100 -translate-x-1/2 sm:translate-x-0" aria-label="Scroll left" data-id="element-48">
              <ChevronLeftIcon size={22} data-id="element-49" />
            </button>}

          {/* Right arrow */}
          {canScrollRight && <button onClick={() => scroll('right')} className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm shadow-md rounded-full p-2.5 text-teal-700 hover:bg-white transition-all opacity-0 group-hover:opacity-100 translate-x-1/2 sm:translate-x-0" aria-label="Scroll right" data-id="element-50">
              <ChevronRightIcon size={22} data-id="element-51" />
            </button>}

          {/* Scrollable track */}
          <div ref={scrollRef} className="flex gap-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory pb-4" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-52">
            {paintings.map((painting, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex-shrink-0 snap-center" data-id="element-53">
                <div className="w-72 sm:w-80 aspect-square rounded-2xl overflow-hidden shadow-md border-4 border-white" data-id="element-54">
                  <img src={painting.src} alt={painting.alt} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" data-id="element-55" />
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}